import routerMain from './index-main'
import routerPublic from './index-public'

const router = process.env.VUE_APP_IS_PUBLIC ? routerPublic : routerMain

export default router
